import type { ContactFlowMetadata } from "~~/model/analytics.model";
import type { ContactPageContentPage } from "~~/model/contact-page.model";

export function useContactPageNotionContentLoader() {
  return useFetch<ContactPageContentPage[]>("/api/contact/contents", {
    key: "contact_page_content",
    getCachedData(key) {
      return useNuxtData(key).data.value;
    },
    default: () => [],
  });
}

export async function useContactPageNotionContent() {
  const { data } = await useContactPageNotionContentLoader();

  function getByMetadata(metadata: ContactFlowMetadata) {
    return data.value?.find((entry) => {
      if (!entry.origin && !entry.origin_page_id && !entry.origin_page_action)
        return false;

      let valid = true;

      if (entry.origin) {
        valid = valid && entry.origin === metadata.origin;
      }

      if (entry.origin_page_id) {
        valid = valid && entry.origin_page_id === metadata.origin_page_id;
      }

      if (entry.origin_page_action) {
        valid =
          valid && entry.origin_page_action === metadata.origin_page_action;
      }

      return valid;
    });
  }

  return {
    getByMetadata,
  };
}
